import { ISchema, ISchemaChild } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";

export const EstablishmentsSchema: ISchema = {
    displayName: "Establishments",
    props: [],

    children: [
        { 
            entityName: EntityNames.accounts, 
            displayName: "Accounts", 
            cantView: false, 
            viewType: EntityViewTypes.list, 
            enableFilters: true,
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Accounts) && hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Add_Account)),
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Accounts))
        } as ISchemaChild,
        { 
            entityName: EntityNames.customers, 
            displayName: "Customers", 
            cantView: false, 
            viewType: EntityViewTypes.list, 
            enableFilters: true,
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Customers) && hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Customer_Accounts) && hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Add_Account)),
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Customers))
        } as ISchemaChild,
    ],
}
